import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import ExperienceFeature from './features/experience';
import HazardFeature from './features/hazard';
import FinancesFeature from './features/finances';
import AnalyseFeature from './features/analyse';
import AgreementsFeature from './features/agreements';
import PDFFeature from './features/pdf';
import { selectIsPrivileged } from '../../../auth/ducks';

function InvestingFeature() {
  const isPrivileged = useSelector(selectIsPrivileged);

  return (
    <Routes>
      <Route path="experience" element={<ExperienceFeature isPrivileged={isPrivileged} />} />
      <Route path="hazard" element={<HazardFeature isPrivileged={isPrivileged} />} />
      <Route path="finances" element={<FinancesFeature isPrivileged={isPrivileged} />} />
      <Route path="analyse" element={<AnalyseFeature isPrivileged={isPrivileged} />} />
      <Route path="agreements" element={<AgreementsFeature isPrivileged={isPrivileged} />} />
      <Route path="pdf" element={<PDFFeature />} />
      <Route path="*" element={<Navigate to="../experience" replace />} />
    </Routes>
  );
}

export default InvestingFeature;
